export type AuditStatus = 'SUCCESS' | 'FAILURE';

export const AUDIT_ACTIONS = [
  'LOGIN',
  'LOGOUT',
  'IMPERSONATE',
  'REGISTER',
  'CREATE',
  'UPDATE',
  'DELETE',
  'SUBSCRIBE',
  'UNSUBSCRIBE',
  'INVITE',
  'ACCEPT_INVITATION',
  'PASSWORD_RESET',
  'PASSWORD_RESET_REQUEST',
  'START',
  'CANCEL',
] as const;
export const AUDIT_ENTITY_TYPES = [
  'NONE',
  'User',
  'UserSubscription',
  'Project',
  'Invitation',
  'Job',
  'Version',
] as const;
export interface AuditLog {
  id: number;
  occurredAt: string;
  userId: number | null;
  userEmail: string | null;
  action: string;
  entityType: string | null;
  entityId: string | null;
  httpMethod: string | null;
  httpPath: string | null;
  ipAddress: string | null;
  userAgent: string | null;
  status: AuditStatus;
  details: string | null;
}

export interface AuditLogFilters {
  userId?: number;
  action?: string;
  entityType?: string;
  entityId?: string;
  status?: AuditStatus;
  from?: string;
  to?: string;
}

export interface LoadAuditLogsRequest extends AuditLogFilters {
  page: number;
  pageSize: number;
}
